import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Box, Text, Input } from "@chakra-ui/react";
import { updateFormConfig } from "../../../../redux/actions/formConfigActions";
const RedirectExternalBody = ({
  redirectExternalPage,
  dispatchUpdateFormConfig,
}) => {
  const handleOnChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    dispatchUpdateFormConfig({ redirectExternalPage: value });
  };
  return (
    <Box mt="3" className="form-config__body">
      <Text fontSize="14px" mb="4px">
        Enter external URL
      </Text>
      <Input
        w="581px"
        h="32px"
        border="1px"
        borderStyle="solid"
        borderColor="#CFD7DF"
        borderRadius="4px"
        placeholder="Enter URL"
        value={redirectExternalPage}
        onChange={handleOnChange}
      />
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    redirectExternalPage: state.formConfig.redirectExternalPage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchUpdateFormConfig: bindActionCreators(updateFormConfig, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RedirectExternalBody);
